// Polyfills for IE
import './polyfills/element.closest';
import './polyfills/matchMedia';
import 'nodelist-foreach-polyfill';
import 'core-js/features/promise';
import 'core-js/es/symbol/iterator';
import 'core-js/es/object/assign';
import 'core-js/es/array/find';
import 'core-js/es/array/from';
import 'core-js/es/array/includes';
import 'core-js/es/string/includes';
import 'intersection-observer';

// import sample from './lib/sample.js';
import drawer from './lib/drawer.js';
import productsAccessories from './lib/products-accessories.js';
import ctaBarTop from './lib/cta-bar-top.js';
import ctaBarBottom from './lib/cta-bar-bottom.js';
import subNav from './lib/sub-nav.js';
import topBar from './lib/menu-top-bar.js';
import fwMedia from './lib/fw-media.js';
import howItWorks from './lib/how-it-works.js';
import videoPlayer from './lib/video-player.js';
import videoPlayerLink from './lib/video-player-link.js';

import specifications from './lib/specifications.js';
import heroProducts from './lib/hero-products.js';
import marketApps from './lib/market-applications.js';
import megamenu from './lib/megamenu.js';








import footerUnitToggler from './lib/footer-units.js';
import documentation from './lib/documentation.js';
import software from './lib/software-firmware.js';
import productCatalog from './lib/product-catalog.js';
import internalSearch from './lib/internal-search.js';
import {pardotForm} from './lib/pardot-form.js';
import {pageiFrame} from './lib/page-iframe.js';
import bookmarks from './lib/bookmarks.js';
import { instance, trigger} from './lib/modal-trigger.js';

import documentationContextual from './lib/documentation-contextual.js';
import softwareCard from './lib/software-card.js'; //for software/firmware no filtering version
import quickLinks from './lib/quick-links.js';
import homeHero from './lib/home-hero.js';
import searchResults from "./lib/search-results";
import testimonial from "./lib/testimonial";
import patents from "./lib/patents";
import legalCompliance from "./lib/legal-compliance";
import timeline from "./lib/timeline";
import literatureOrder from "./lib/lit-order";
import genericModal from "./lib/generic-modal";
import slideshow from './lib/slideshow.js';
import chatModal from './lib/chat-modal.js';
import store from './lib/store';
import faq from './lib/faq';

// importing libraries for modules
import ComponentModule from './lib/component-module';
import './lib/modules';

document.addEventListener('DOMContentLoaded', () => {
    genericModal();
    drawer();
    productsAccessories();
    ctaBarTop();
    ctaBarBottom();
    subNav();
    topBar();
    fwMedia();
    howItWorks();
    videoPlayer();
    videoPlayerLink();
    
    specifications();
    heroProducts();
    marketApps();
    megamenu();
    footerUnitToggler();
    documentation();
    software();
    productCatalog();
    internalSearch();
    pageiFrame();
    pardotForm();
    bookmarks();
    // Initialization modules
    ComponentModule.Init();
    instance;
    trigger();
    documentationContextual();
    softwareCard();
    quickLinks();
    homeHero();
    searchResults();
    testimonial();
    patents();
    legalCompliance();
    timeline();
    literatureOrder();
    slideshow();
    chatModal();
    faq();

    // always scroll lock body when modal or mobile megamenu is open
    let observerTarget = document.querySelector('body');
    let scrollLock = () => {
        if (document.querySelector('.bmi-modal') || document.querySelector('.megamenu__mobile-submenu.active')) {
            observerTarget.classList.add('scroll-lock');
        } else {
            observerTarget.classList.remove('scroll-lock');
        }
    }
    let options = {
        subtree: true,
        childList: true
    }
    let observer = new MutationObserver(scrollLock);
    observer.observe(observerTarget, options);

    // init units to us or metric
    store.dispatch('initUnits');
    // init getting GA client ID
    store.dispatch('initGAID');
});

store.dispatch('initCookies'); //init cookies for bookmark feature
store.dispatch('checkMobile'); 
